const hasExplicitTimeZone = (value) => /([zZ]|[+-]\d{2}:\d{2})$/.test(value);

export const parseApiDateTime = (value) => {
  if (!value) return null;
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  const raw = String(value).trim();
  if (!raw) return null;

  if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) {
    const parsedDateOnly = new Date(`${raw}T00:00:00`);
    return Number.isNaN(parsedDateOnly.getTime()) ? null : parsedDateOnly;
  }

  const normalized = raw.includes(" ") ? raw.replace(" ", "T") : raw;
  const utcCandidate = hasExplicitTimeZone(normalized) ? normalized : `${normalized}Z`;
  const parsed = new Date(utcCandidate);

  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

export const formatDateTimeForUser = (value) => {
  const parsed = parseApiDateTime(value);
  if (!parsed) return "-";

  return new Intl.DateTimeFormat(undefined, {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    second: "2-digit",
  }).format(parsed);
};

export const formatDateForUser = (value) => {
  const parsed = parseApiDateTime(value);
  if (!parsed) return "-";

  return new Intl.DateTimeFormat(undefined, {
    year: "numeric",
    month: "numeric",
    day: "numeric",
  }).format(parsed);
};
